import { render, staticRenderFns } from "./AddCrownMap.vue?vue&type=template&id=6392fa9a&scoped=true&"
import script from "./AddCrownMap.vue?vue&type=script&lang=js&"
export * from "./AddCrownMap.vue?vue&type=script&lang=js&"
import style0 from "./AddCrownMap.vue?vue&type=style&index=0&id=6392fa9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6392fa9a",
  null
  
)

export default component.exports